<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <Title>基础信息</Title>
      <el-descriptions title="">
        <el-descriptions-item label="审批编号">{{info.id}}</el-descriptions-item>
        <el-descriptions-item label="提交时间">{{info.operatedTime}}</el-descriptions-item>
        <el-descriptions-item label="申请类型">修改认证信息</el-descriptions-item>
        <el-descriptions-item label="提交申请类型">{{getSubmitApplyTypeName(info.submitApplyType)}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{info.auditStatus==0?'待审核':info.auditStatus==1?'同意申请':'驳回申请'}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{info.rejectCause}}</el-descriptions-item>
        <el-descriptions-item label="审核备注" v-if="info.auditRemark">{{info.auditRemark}}</el-descriptions-item>
        <el-descriptions-item label="审核上传图片" v-if="info.auditUrl">
          <div style="display: flex;justify-content: center;" >
            <el-image style="width: 50px;"  :src="item" :preview-src-list="[item]" v-for="(item,index) in info.auditUrl.split(',')" :key="index"></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <Title class="mt20">申请人信息</Title>
      <el-descriptions title="">
        <el-descriptions-item label="姓名">{{info.applyName}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{info.applyPho}}</el-descriptions-item>
        <el-descriptions-item label="身份">{{info.applyLevelName}}</el-descriptions-item>
      </el-descriptions>
      <Title class="mt20">客户信息</Title>
      <el-descriptions title="">
        <el-descriptions-item label="姓名">{{info.customerName}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{info.customerPho}}</el-descriptions-item>
        <el-descriptions-item label="身份">{{info.customerLevelName}}</el-descriptions-item>
      </el-descriptions>
      <Title class="mt20">实名认证：<span :style="{'color': info.certificatesType	?'#0D862F':'#E73F3F'}">{{info.certificatesType ?'已认证':'未认证'}}</span>
      </Title>
      <template v-if="info.auditStatus==1">
        <el-descriptions title="" v-if="info.certificatesType==1">
          <el-descriptions-item label="认证类型">企业认证</el-descriptions-item>
          <el-descriptions-item label="门店类型">{{info.companyType}}</el-descriptions-item>
          <el-descriptions-item label="企业全称">{{info.companyName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="所在地">{{info.customerCertificates.companyType}}</el-descriptions-item> -->
          <el-descriptions-item label="资质证件类型">{{info.companyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码/身份证">{{info.code}}</el-descriptions-item>
          <!-- <el-descriptions-item label="纳税人识别号">{{info.taxpayerCode}}</el-descriptions-item> -->
          <!-- REQ-2026-639960：专票资质的唯一来源，只有标记成「一般纳税人」的客户才能在 APP 申请增值税专用发票 -->
          <el-descriptions-item label="纳税人类型">
            <el-select v-model="taxpayerType" placeholder="未标记" size="mini" style="width: 140px;">
              <el-option label="一般纳税人" :value="1" />
              <el-option label="小规模纳税人" :value="2" />
            </el-select>
            <el-button type="primary" size="mini" class="ml10" :loading="taxpayerSaving" @click="handleSaveTaxpayerType">保存</el-button>
            <div style="color: #909399; font-size: 12px; margin-top: 4px;">标记为「一般纳税人」后，该客户在 APP 端才能选择开具增值税专用发票</div>
          </el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="资质证件">
            <el-image style="width: 150px;" :src="info.certificatesImg" :preview-src-list="[info.certificatesImg]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" v-if="info.certificatesType==2">
          <el-descriptions-item label="认证类型">个人认证</el-descriptions-item>
          <el-descriptions-item label="姓名">{{info.companyName}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.code}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-image style="width: 150px;" :src="info.certificatesImg.split(',')[0]" :preview-src-list="info.certificatesImg.split(',')"></el-image>
            <el-image style="width: 150px;" class="ml10" :src="info.certificatesImg.split(',')[1]" :preview-src-list="info.certificatesImg.split(',')"></el-image>
          </el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else>
        <el-descriptions title="" v-if="info.waitCertificatesType==1">
          <el-descriptions-item label="认证类型">企业认证</el-descriptions-item>
          <el-descriptions-item label="门店类型">{{getCompanyTypeName(info.waitCompanyType)}}</el-descriptions-item>
          <el-descriptions-item label="企业全称">{{info.waitCompanyName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="所在地">{{info.customerCertificates.companyType}}</el-descriptions-item> -->
          <el-descriptions-item label="资质证件类型">{{info.waitCompanyZiZhi==2?'医疗机构职业许可证':'营业执照'}}</el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码/身份证">{{info.waitCode}}</el-descriptions-item>
          <!-- <el-descriptions-item label="纳税人识别号">{{info.waitTaxpayerCode}}</el-descriptions-item> -->
          <el-descriptions-item label="提交认证时间">{{dayjs(info.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="资质证件">
            <el-image style="width: 150px;" :src="info.waitCertificatesImg" :preview-src-list="[info.waitCertificatesImg]"></el-image>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="" v-if="info.waitCertificatesType==2">
          <el-descriptions-item label="认证类型">个人认证</el-descriptions-item>
          <el-descriptions-item label="姓名">{{info.waitCompanyName}}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{info.waitCode}}</el-descriptions-item>
          <el-descriptions-item label="提交认证时间">{{dayjs(info.createdTime).format("YYYY-MM-DD HH:mm:ss")}}</el-descriptions-item>
          <el-descriptions-item label="身份证">
            <el-image style="width: 150px;" :src="info.waitCertificatesImg.split(',')[0]" :preview-src-list="info.waitCertificatesImg.split(',')"></el-image>
            <el-image style="width: 150px;" class="ml10" :src="info.waitCertificatesImg.split(',')[1]" :preview-src-list="info.waitCertificatesImg.split(',')"></el-image>
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </el-card>
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
    </el-dialog>
  </div>
</template>

<script>
import custApi from '@/api/cust'
import meetingSignUpApi from '@/api/meeting/meetingSignUp'
import invoiceApplicationAuditApi from '@/api/finance/invoiceApplicationAudit'
export default {
  props: ['rowId'],
  data() {
    return {
      radio1: '全部',
      activeType: '0',
      list: [],
      formVisible: false,
      info: {
        userHeadImg: ''
      },
      technicalState: 1,
      shareData: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      areaOptions: [],
      statisticsList: [],
      // REQ-2026-639960 纳税人类型 1一般纳税人 2小规模纳税人
      taxpayerType: undefined,
      taxpayerSaving: false
    }
  },
  created() {
    this.handleShow()
    // if (this.rowItem.areaCount) this.changeIdentity()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    // 提交申请类型转换为中文名称
    getSubmitApplyTypeName(submitApplyType) {
      const submitApplyTypeMap = {
        1: '自己提交',
        2: '业务员提交',
        3: '后台提交',
        4: '主账号提交'
      }
      return submitApplyTypeMap[submitApplyType] || ''
    },
    // 将门店类型数字转换为中文名称
    getCompanyTypeName(companyType) {
      const companyTypeMap = {
        0: '诊所',
        1: '私立医院',
        2: '卫生室',
        3: '单体店',
        4: '社区卫生服务站',
        5: '美容院'
      }
      // 如果传入的是字符串（非数字），直接返回；如果是数字，返回对应中文名称；否则返回原值
      if (typeof companyType === 'string' && isNaN(companyType)) {
        return companyType
      }
      const num = Number(companyType)
      return companyTypeMap[num] !== undefined ? companyTypeMap[num] : companyType
    },
    handleShow() {
      custApi.fetchById(this.rowId)
        // technicianInfoApi.fetchById(this.rowItem.id)
        // technicianInfoApi.fetchById(4)
        .then((data) => {
          this.info = data.data;
          // REQ-2026-639960 回显已标记的纳税人类型
          this.taxpayerType = this.info.taxpayerType || undefined
          // this.getServiceNum()
          // this.getClientNum()
          console.log('this.form: ', this.info);
        })
    },
    // REQ-2026-639960 标记纳税人类型，一般纳税人才允许在 APP 端开专票
    handleSaveTaxpayerType() {
      if (!this.taxpayerType) {
        this.$message.warning('请先选择纳税人类型')
        return
      }
      if (!this.info.customerId) {
        this.$message.error('未取到客户id，无法标记')
        return
      }
      this.taxpayerSaving = true
      invoiceApplicationAuditApi
        .updateTaxpayerType({ customerId: this.info.customerId, taxpayerType: this.taxpayerType })
        .then(() => {
          this.$message.success('已保存')
          this.handleShow()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '保存失败')
        })
        .finally(() => {
          this.taxpayerSaving = false
        })
    },
    showArea() {
      this.formVisible = true
    },
    // 获取地区
    changeIdentity() {
      technicianAreaApi.fetchTreeList({
        technicianInfoId: this.rowItem.id,
        isGetAuth: true
      }).then(({
        data
      }) => {
        this.areaOptions = data
      })
    },
    // 切换
    handleCheck() {
      if (this.activeType == 1) {
        this.statisticsList = [{
          label: '普通客户',
          key: '8',
          unit: '人',
          value: 0
        },
        {
          label: '体验班',
          key: '7',
          unit: '人',
          value: 0
        },
        {
          label: '研修班',
          key: '6',
          unit: '人',
          value: 0
        },
        ]
        // this.getClientNum()
      }
      if (this.activeType == 2) {
        this.statisticsList = [{
          label: '营销经理',
          key: '',
          unit: '人',
          value: 0
        },
        {
          label: '大区经理',
          key: '10',
          unit: '人',
          value: 0
        },
        {
          label: '地区经理',
          key: '20',
          unit: '人',
          value: 0
        },
        {
          label: '县区经理',
          key: '30',
          unit: '人',
          value: 0
        }
        ]
        // this.getServiceNum()
      }
      if (this.activeType == 3) {
        this.statisticsList = [{
          label: '总业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '直属客户业绩',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '团队业绩',
          key: '',
          unit: '元',
          value: 0
        }
        ]
        // this.getChildNum()
      }
      if (this.activeType == 4) {
        this.statisticsList = [{
          label: '累计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '预计佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '已提现佣金',
          key: '',
          unit: '元',
          value: 0
        },
        {
          label: '可提现佣金',
          key: '',
          unit: '元',
          value: 0
        }
        ]
      }
    },
    // 获取预约服务数量
    async getServiceNum() {
      const {
        data
      } = await technicianServiceOrderApi.getStatusCount({
        technicianInfoId: this.rowItem.id
      })
      // console.log('服务数量: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
          this.statisticsList[0].value = data.reduce((total, current) => {
            return total + current.count
          }, 0)
        })
        console.log('this.statisticsList: ', this.statisticsList);
      }
    },
    // 获取客户数量
    async getClientNum() {
      const {
        data
      } = await clientListApi.getCountByLevelGroup({
        technicianId: this.info.id
      })
      // console.log('客户数量data: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
        })
        // console.log('this.statisticsList: ',this.statisticsList);
      }
    },
    // 获取团队数量
    async getChildNum() {
      const {
        data
      } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
